import { useEffect, useState } from 'react';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { userStatusOptions, userTypeOptions } from '../config';
import { UsersFilter } from '../models';
import { UserStatus } from '../enums';
import type { UserTypeFilter } from '../enums/UserType';
import { useDebounce } from '@/hooks';
import {
  GlobalButton,
  SearchInput,
  SelectInput,
} from '@/components';
import { DeleteForever as TrashIcon } from '@mui/icons-material';

interface SearchBarProps {
  onSearch: (filters: UsersFilter) => void;
  initialFilter: UsersFilter;
  currentFilter: UsersFilter;
}

const SearchBar = ({
  onSearch,
  initialFilter,
  currentFilter,
}: SearchBarProps) => {
  const [search, setSearch] = useState(currentFilter.search ?? '');
  const [phoneNumber, setPhoneNumber] = useState(currentFilter.phoneNumber ?? '');
  const [userType, setUserType] = useState<UserTypeFilter | ''>(
    currentFilter.userType ?? ''
  );
  const [status, setStatus] = useState<UserStatus | ''>(
    currentFilter.status ?? ''
  );

  const debouncedSearch = useDebounce(search, 350);
  const debouncedPhone = useDebounce(phoneNumber, 350);

  useEffect(() => {
    onSearch({
      search: debouncedSearch.trim() || undefined,
      phoneNumber: debouncedPhone.trim() || undefined,
      userType: userType || undefined,
      status: status || undefined,
    });
  }, [debouncedSearch, debouncedPhone, userType, status, onSearch]);

  const resetFilter = () => {
    setSearch('');
    setPhoneNumber('');
    setUserType('');
    setStatus('');
    onSearch(initialFilter);
  };

  return (
    <div className='w-full flex flex-col justify-center gap-5 p-5 bg-white rounded-sm shadow-xl'>
      <h3 className='text-lg font-semibold text-gray-800'>
        Filtros de búsqueda
      </h3>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4'>
        <div className='md:col-span-2'>
          <SearchInput
            name='user-search'
            placeholder='Nombre, apellido o email'
            value={search}
            onChange={setSearch}
          />
        </div>
        <SearchInput
          name='user-phone-search'
          placeholder='Teléfono'
          value={phoneNumber}
          // El back compara solo los digitos, asi que se deja escribir el
          // numero como cada uno lo tenga a mano: 099 123 456, +598 99 123 456
          // o (099) 123-456 buscan lo mismo.
          onChange={(val) => setPhoneNumber(val.replace(/[^0-9+()\s-]/g, ''))}
        />
        <SelectInput
          name='user-type-search'
          placeholder='Tipo'
          value={userType}
          onChange={(value) =>
            setUserType(value ? (value as UserTypeFilter) : '')
          }
          options={userTypeOptions}
        />
        <SelectInput
          name='user-status-search'
          placeholder='Estado'
          value={status}
          onChange={(value) =>
            setStatus(value ? (value as UserStatus) : '')
          }
          options={userStatusOptions}
        />
      </div>
      <div className='flex gap-3 justify-end'>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilter}
        >
          <TrashIcon color='primary' />
          Limpiar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
